import React from 'react';
import PropTypes from 'prop-types';

// Styles
import styles from './snapshotLegend.css';

const SnapshotLegend = ({ data }) => {
  const legend = data
    // Divide data into buckets by key
    .reduce((acc, datum) => {
      const { bucket: index } = datum;

      // Add datum to accumulator array at index value
      if (acc[index]) {
        acc[index].push(datum);
      } else {
        acc[index] = [datum];
      }
      return acc;
    }, [])
    // Transform buckets into objects with a color property and array object
    .map((bucket) => ({
      color: bucket[0].color,
      values: bucket.reduce((acc, { value }) => ([...acc, value]), []),
    }))
    // Calulate the min and max of the range of values
    .map(({ color, values }) => ({
      color,
      min: Math.min(...values),
      max: Math.max(...values),
    }))
    // Use the formatted value instead of the numeric value
    .map(({ color, min, max }) => ({
      color,
      min: data.find(({ value }) => (value === min)).formattedValue,
      max: data.find(({ value }) => (value === max)).formattedValue,
    }));

  return (
    <div className={styles.snapshotLegend}>
      <ol
        className={styles.gradient}
      >
        {legend
          .map(({ color, min, max }) => (
            <li
              className={styles.key}
              key={color}
            >
              <div
                className={styles.colorBlock}
                style={{ backgroundColor: color }}
              />
              <div
                className={styles.label}
              >
                {min.toLocaleString()}
                {max !== min && `- ${max.toLocaleString()}`}
              </div>
            </li>
          ))
        }
      </ol>
    </div>
  );
};

SnapshotLegend.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      bucket: PropTypes.number.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
      color: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};

export default SnapshotLegend;



// WEBPACK FOOTER //
// ./app/components/snapshotLegend/index.js